import type { TourConfig } from '../types';

export const reportsPageTour: TourConfig = {
  pageId: 'reports',
  pageName: 'Commission Reports',
  portalId: 'crm',
  steps: [
    {
      element: '[data-tour="report-date-range"]',
      title: 'Date Range',
      intro:
        'Choose a preset date range (current quarter, previous quarter, year-to-date) or define a custom range.',
      platform: 'both',
    },
    {
      element: '[data-tour="report-filters"]',
      title: 'Report Filters',
      intro:
        'Filter by sales rep, referral source, and commission status to narrow your report scope.',
      platform: 'both',
    },
    {
      element: '[data-tour="report-actions"]',
      title: 'Generate & Export',
      intro:
        'Click "Generate Report" to run the query. Once generated, "Export CSV" downloads the data as a spreadsheet.',
      platform: 'both',
    },
    {
      element: '[data-tour="report-table"]',
      title: 'Report Results',
      intro:
        'View project-level commission data in a sortable table. Summary cards above show totals at a glance.',
      platform: 'both',
    },
  ],
};
